import { render, staticRenderFns } from "./under.vue?vue&type=template&id=8004ede0&scoped=true&"
import script from "./under.vue?vue&type=script&lang=js&"
export * from "./under.vue?vue&type=script&lang=js&"
import style0 from "./under.vue?vue&type=style&index=0&id=8004ede0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8004ede0",
  null
  
)

export default component.exports